const DEV = process.env.NODE_ENV === 'development'
import OpenSeadragon from 'openseadragon'
import Swiper from 'swiper'
import { Mousewheel, Navigation } from 'swiper/modules'
import 'swiper/css'

export default {
  init() {
    /* Commons */

    let content = document.getElementById('mainContent')

    /* Timer viewer */
    let timerViewer,
      interval,
      articleHeader = document.getElementById('articleHeader'),
      articleTime = document.getElementById('articleTime'),
      timeM = document.getElementById('timeM'),
      timeS = document.getElementById('timeS'),
      endText = document.getElementById('endText'),
      endTextOrignal = endText.innerHTML,
      openTimerBtn = document.getElementById('openTimer'),
      firstAccessDiv = document.getElementById('firstAccess'),
      replayTextDiv = document.getElementById('replayText'),
      startTimerBtn = document.getElementById('startTimer'),
      timerImage = document.getElementById('timerImage'),
      timerOverlay = document.getElementById('timerOverlay'),
      backBtn = document.getElementById('backBtn'),
      intro = document.getElementById('paintingIntro'),
      timer = document.getElementById('timer')

    const TOOLTIP_DELAY_MS = 3000
    const CLOSE_TOOLTIP_DELAY_MS = 1000
    const MOBILE_TOOLTIP_AUTO_HIDE_MS = 3000

    let startTooltip = document.getElementById('startTooltip')
    let closeTooltip = document.getElementById('closeTooltip')
    let closeTooltipBtn = document.getElementById('closeTooltipBtn')
    let closeTooltipDismissed = false

    let titeSource = 'Devo capire cosa è'

    const setupViewer = () => {
      timerViewer = OpenSeadragon({
        id: 'timerImage',
        tileSources: null,
        autoHideControls: false,
        //visibilityRatio: 1,
        //constrainDuringPan: true,
        zoomInButton: 'zoomInButton',
        zoomOutButton: 'zoomOutButton',
        fullPageButton: 'fullscreenBtn',
      })
    }

    const swiperTimer = new Swiper('.timer_swiper', {
      speed: 700,
      modules: [Mousewheel, Navigation],
      direction: 'vertical',
      mousewheel: {
        enabled: true,
        sensitivity: 1,
      },
      navigation: {
        nextEl: '#nextSlide',
      },
    })

    const openDrawer = () => {
      timerOverlay.classList.add('active')
      document.documentElement.classList.add('overflow-hidden')
      if (!timerViewer) {
        setupViewer()
      } else {
        timerImage.style.display = 'block'
      }
      initCanvas()
    }

    const startDrawer = () => {
      if (intro) intro.classList.add('closed')

      showCloseTooltip()
      const toolbar = document.querySelector('.dock')
      toolbar?.classList.remove('opacity-0')
      revealHint?.()

      startTimer(timer, 30, () => {
        console.log('timer is up')
      })
    }

    const closeDrawer = () => {
      hideCloseTooltip()
      closeTooltipDismissed = false
      stopCanvas?.()
      const toolbar = document.querySelector('.dock')
      toolbar?.classList.add('opacity-0')
      document.getElementById('hint')?.classList.add('gone')
      timerOverlay.classList.remove('active')
      document.documentElement.classList.remove('overflow-hidden')
      intro.classList.remove('closed')
      timerImage.style.display = 'none'
      content.style.display = 'block'
      //articleHeader.style.display = 'none';
      articleTime.classList.remove('hidden')
      firstAccessDiv.classList.add('hidden')
      replayTextDiv.classList.remove('hidden')
      articleTime.scrollIntoView()
      resetDrawer()
    }

    const resetDrawer = () => {
      clearInterval(interval)
      timer.innerHTML = '00:00'
      timerViewer.viewport.goHome()
      swiperTimer.slideTo(0)
    }

    const startTimer = (element, durationInMinutes, onComplete) => {
      const display = element
      let totalSeconds = durationInMinutes * 60
      let currentSeconds = 0

      interval = setInterval(() => {
        currentSeconds++

        const minutes = Math.floor(currentSeconds / 60)
        const seconds = currentSeconds % 60

        display.innerHTML =
          String(minutes).padStart(2, '0') +
          ':' +
          String(seconds).padStart(2, '0')

        timeM.innerHTML = String(minutes).padStart(2, '0')
        timeS.innerHTML = String(seconds).padStart(2, '0')
        //hide all range texts
        document.getElementById('range-1').classList.add('hidden')
        document.getElementById('range-2').classList.add('hidden')
        document.getElementById('range-3').classList.add('hidden')
        document.getElementById('range-4').classList.add('hidden')
        if (currentSeconds <= 60) {
          document.getElementById('range-1').classList.remove('hidden')
        } else if (currentSeconds > 59 && currentSeconds <= 420) {
          document.getElementById('range-2').classList.remove('hidden')
        } else if (currentSeconds > 119 && currentSeconds <= 600) {
          document.getElementById('range-3').classList.remove('hidden')
        } else {
          document.getElementById('range-4').classList.remove('hidden')
        }
        // endText.innerHTML = endTextOrignal
        //   .replace('#M', minutes)
        //   .replace('#S', seconds)

        if (currentSeconds >= totalSeconds) {
          clearInterval(interval)
          if (typeof onComplete === 'function') {
            onComplete()
          }
        }
      }, 1000)
    }

    let tooltipTimeout = null
    if (startTooltip) {
      tooltipTimeout = setTimeout(() => {
        startTooltip.classList.remove(
          'opacity-0',
          'translate-y-3',
          'pointer-events-none'
        )
        startTooltip.classList.add('opacity-100', 'translate-y-0')
      }, TOOLTIP_DELAY_MS)
    }

    const hideTooltip = () => {
      if (startTooltip) {
        startTooltip.classList.add(
          'opacity-0',
          'translate-y-3',
          'pointer-events-none'
        )
        startTooltip.classList.remove('opacity-100', 'translate-y-0')
      }
    }

    let closeTooltipTimeout = null

    const showCloseTooltip = () => {
      if (closeTooltipDismissed || !closeTooltip) return
      closeTooltipTimeout = setTimeout(() => {
        if (closeTooltipDismissed) return
        closeTooltip.classList.remove(
          'opacity-0',
          '-translate-y-2',
          'pointer-events-none'
        )
        closeTooltip.classList.add('opacity-100')
        closeTooltip.style.transform = 'translate(-50%,-10%)'
        if (window.matchMedia('(hover: none) and (pointer: coarse)').matches) {
          setTimeout(hideCloseTooltip, MOBILE_TOOLTIP_AUTO_HIDE_MS)
        }
      }, CLOSE_TOOLTIP_DELAY_MS)
    }

    const hideCloseTooltip = () => {
      clearTimeout(closeTooltipTimeout)
      closeTooltipDismissed = true
      if (!closeTooltip) return
      closeTooltip.classList.add(
        'opacity-0',
        '-translate-y-2',
        'pointer-events-none'
      )
      closeTooltip.classList.remove('opacity-100')
      closeTooltip.style.transform = 'translate(-50%, 100%)'
    }

    if (closeTooltipBtn) {
      closeTooltipBtn.addEventListener('click', hideCloseTooltip)
    }

    if (openTimerBtn) {
      openTimerBtn.addEventListener('click', (e) => {
        clearTimeout(tooltipTimeout)
        hideTooltip()
        openDrawer()
      })
    }

    if (startTimerBtn) {
      startTimerBtn.addEventListener('click', startDrawer)
    }

    if (backBtn) {
      backBtn.addEventListener('click', closeDrawer)
    }

    /* Visit Drawer */
    let visitViewer,
      openVisitBtn = document.getElementById('openVisit'),
      visitImage = document.getElementById('visitImage'),
      visitOverlay = document.getElementById('visitOverlay'),
      backBtnVisit = document.getElementById('backBtnVisit')

    const setupVisitViewer = () => {
      visitViewer = OpenSeadragon({
        id: 'visitImage',
        tileSources:
          'https://openseadragon.github.io/example-images/duomo/duomo.dzi',
        showZoomControl: false,
        showHomeControl: false,
        showFullPageControl: false,
        showRotationControl: false,
        showNavigator: false,
      })
    }

    const openVisitDrawer = () => {
      visitOverlay.classList.add('active')
      document.documentElement.classList.add('overflow-hidden')
      if (!visitViewer) {
        setupVisitViewer()
      } else {
        visitImage.style.display = 'block'
      }
    }

    const closeVisitDrawer = () => {
      visitOverlay.classList.remove('active')
      document.documentElement.classList.remove('overflow-hidden')
      if (visitViewer) {
        visitImage.style.display = 'none'
      }
      swiper.slideTo(0)
      content.style.display = 'block'
      content.scrollIntoView()
    }

    const swiper = new Swiper('.visit_swiper', {
      speed: 700,
      modules: [Mousewheel],
      direction: 'vertical',
      mousewheel: {
        enabled: true,
        sensitivity: 1,
      },
    })

    swiper.on('slideChange', () => {
      const activeSlide = swiper.slides[swiper.activeIndex]
      const x = parseFloat(activeSlide.getAttribute('data-x'))
      const y = parseFloat(activeSlide.getAttribute('data-y'))

      if (!visitViewer || !visitViewer.viewport) return

      if (x === 0 && y === 0) {
        visitViewer.viewport.goHome()
        return
      }

      let coord = new OpenSeadragon.Point(x, y)
      if (visitViewer.viewport.getZoom() != 4) {
        visitViewer.viewport.zoomTo(4, coord)
      } else {
        visitViewer.viewport.panTo(coord)
      }
    })

    if (openVisitBtn) {
      openVisitBtn.addEventListener('click', openVisitDrawer)
    }

    if (backBtnVisit) {
      backBtnVisit.addEventListener('click', closeVisitDrawer)
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
}
